module.exports = {
  fonts: {
    body: `'Manrope', Helvetica, Arial, sans-serif`,
    title: `'Plus Jakarta Sans', Helvetica, Arial, sans-serif`,
    text: `'Manrope', Helvetica, Arial, sans-serif`,
  },
  colors: {
    background: '--background',
    'text-primary': '--text-primary',
    'text-secondary': '--text-secondary',
    'text-content': '--text-content',
    'accent-primary': '--accent-primary',
  },
  sizes: {
    default: 'max(50vw, 760px)',
    max: '760px',
    min: '340px',
  },
}
